import { Directive, ElementRef, Input, OnInit, Renderer2, SecurityContext } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { COMPONENT_IMAGE_PLACEHOLDER } from './utils/image-placeholder.util';

@Directive({
  selector: '[appFetchComponentImage]'
})
export class FetchComponentImageDirective implements OnInit {
  @Input() appFetchComponentImage: string | null = null;

  constructor(
    private el: ElementRef,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    if (typeof this.appFetchComponentImage === 'string' && this.appFetchComponentImage.trim().length > 0) {
      this.fetchImage(this.appFetchComponentImage);
    }
  }

  private fetchImage(imageFileName: string): void {
    this.http.get(`components/images/${imageFileName}`, { responseType: 'blob' }).subscribe((res: Blob) => {
      const imageSafeUrl = this.sanitizer.sanitize(SecurityContext.URL, this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res)));
      if (imageSafeUrl) {
        this.renderer.setAttribute(this.el.nativeElement, 'src', imageSafeUrl);
        this.renderer.removeClass(this.el.nativeElement, 'is-placeholder');
      }
    }, (error: any) => {
      this.renderer.setAttribute(this.el.nativeElement, 'src', COMPONENT_IMAGE_PLACEHOLDER);
      this.renderer.addClass(this.el.nativeElement, 'is-placeholder');
    });
  }
}
